import React, { Component } from 'react';
import { Link } from 'react-static';
import moment from 'moment';

import './style.scss';

export default class BlogPostTiles extends Component {
  state = {
    visibleItems: [],
    isFetchingData: false,
    isShowMoreVisible: false,
  };

  setVisibleItems() {
    const { items, pageNum, pageCount } = this.props.data;

    if (!items) {
      return;
    }

    this.setState(state => ({
      ...state,
      visibleItems: [...items],
      isFetchingData: false,
      isShowMoreVisible: pageCount > pageNum,
    }));
  }

  onShowMoreClick() {
    const {
      data: { pageNum, pageCount },
      fetchMoreArticles,
    } = this.props;
    const { isFetchingData } = this.state;

    if (isFetchingData || pageNum >= pageCount) {
      return;
    }

    this.setState(
      state => ({
        ...state,
        isFetchingData: true,
      }),
      () => fetchMoreArticles(),
    );
  }

  componentDidUpdate() {
    const { items } = this.props.data;
    const { visibleItems } = this.state;

    if (visibleItems && visibleItems.length < items.length) {
      this.setVisibleItems();
    }
  }

  componentDidMount() {
    this.setVisibleItems();
  }

  render() {
    const { id, lang, t } = this.props;
    const { visibleItems, isShowMoreVisible } = this.state;

    return (
      <div id={id} className="blog-post-tiles content-wrap">
        <div className="grid vertical">
          <div className="grid-row">
            <h1>{t('widgets.articles.header')}</h1>
          </div>
          <div className="grid-row">
            {visibleItems.map(article => (
              <div
                className="card-wrapper"
                key={`blog-post-tiles_${article.id}`}
              >
                <Link to={`/blog/post?id=${article.id}`}>
                  <div className="blog-post-tiles--card">
                    <img src={article.imageSrc} alt="image" />
                    <div className="blog-post-tiles--card--content">
                      <div className="blog-post-tiles--card--text">
                        {article.title}
                      </div>
                      {article.date && (
                        <div className="blog-post-tiles--card--footer">
                          {moment(article.date)
                            .locale(lang)
                            .format(lang === 'en' ? 'D MMMM, Y' : 'LL')}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
        {isShowMoreVisible && (
          <div
            className="grid-item center"
            style={{ justifyContent: 'center' }}
          >
            <a
              onClick={() => this.onShowMoreClick()}
              className="button type_white"
            >
              {t('widgets.articles.showMoreBtn')}
            </a>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /app/apps/ms/src/components/BlogPostTiles/index.js